module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Thin-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Thin-webfont.svg
// module id = 1624
// module chunks = 0